module.exports = __webpack_public_path__ + "img/introduction_trouble.d16eb2b7.jpg";